import type { FindingVariant } from "./FindingProps";

// Размер иконки карточки: в короткой плашке меньше, в «Главном» — крупнее.
export const iconSize = (variant: FindingVariant | undefined): number =>
  variant === "compact" ? 40 : variant === "lead" ? 64 : 44;
